<template>
  <div class="login-wrapper">
    <div class="content-wrapper">
      <div class="content">
        <div class="content-head">
          <div class="label">体验课</div>
          <div class="text">{{ titleText }}</div>
        </div>
        <div class="form">
          <van-form>
            <van-field
              class="form-item"
              v-model="form.userName"
              required
              label="学生姓名"
              placeholder="请输入学生姓名"
            />
            <van-field
              class="form-item"
              v-model="form.mobile"
              type="tel"
              required
              label="手机号"
              placeholder="请输入手机号"
              name="validator"
            />
            <van-field
              class="form-item"
              v-model="form.smsCode"
              required
              center
              clearable
              label="验证码"
              placeholder="请输入验证码"
            >
              <template #button>
                <van-button size="small" type="primary" @click="getSmsCode">{{
                  smsText
                }}</van-button>
              </template>
            </van-field>
          </van-form>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <div class="text">应付：</div>
        <div class="price">
          <div class="icon">￥</div>
          <div class="text">{{ price }}</div>
        </div>
      </div>
      <div class="btn" @click="submit">确认兑换</div>
    </div>
  </div>
</template>
<script>
import { Form, Field, Button, Toast } from "vant"
import { getClass, getExchangeCourse } from "../../request/api/common"
import { smsCode, getopenid } from "../../request/api/user"
import { ERROR_OK } from "../../request/http"
import wx from "weixin-js-sdk"
import { getAppId, getSdk } from "../../request/api/study"
export default {
  data () {
    return {
      form: {
        mobile: "",
        smsCode: "",
        userName: "",
      },
      list: [],
      isSend: false,
      countdown: 60,
      currentIndex: "",
      imgUrl: "",
      isSubmit: false
    }
  },
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast
  },
  computed: {
    smsText () {
      return this.isSend ? `${this.countdown}s重新获取` : "发送验证码"
    },
    isMobile () {
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.form.mobile)
    },
    titleText () {
      let text = ""
      if (this.channelId == 2) {
        text = "泰康专属双周趣味思维体验课"
      } else {
        text = "趣味思维体验课"
      }
      return text
    },
    price () {
      let price = ""
      if (this.channelId == 2) {
        price = 168
      } else {
        price = 99.9
      }
      return price
    }
  },
  created () {
    this.getWxCode()
    this.channelId = this.$route.query.channelId
    // this.getClassList()
    if (
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      this.getAppIdInfo()
    }
  },
  methods: {
    getUrlParam (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    getWxCode () {
      let code = this.getUrlParam("code")
      getopenid({ code }).then(res => {
        this.openid = res.data.openid
      })
    },
    validator (val) {
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val)
    },
    async getClassList () {
      let { code, data } = await getClass({
        channelId: this.channelId
      })
      if (code === ERROR_OK) {
        this.list = data || []
      }
    },
    selectClass (item) {
      this.form.classId = item.id
      this.imgUrl = item.weiXinImageUrl
    },
    async getSmsCode () {
      console.log(333)
      if (!this.isMobile || this.isSend) {
        return
      }
      console.log(555)
      let { code } = await smsCode({
        mobile: this.form.mobile
      })
      if (code === ERROR_OK) {
        this.isSend = true
        this.setTime()
      } else {
        Toast.fail({
          type: "fail",
          message: "验证码发送失败，请稍后再试",
          duration: 1000
        })
      }
    },
    setTime () {
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          clearInterval(this.timer)
          this.countdown = 60
          this.isSend = false
        }
        this.countdown--
      }, 1000)
    },
    async submit () {
      let obj = {
        mobile: "",
        smsCode: "",
        userName: "",
      }
      for (let key in obj) {
        if (!this.form[key]) {
          Toast.fail({
            type: "fail",
            message: "请输入基本信息",
            duration: 1000
          })
          return
        }
      }
      if (this.isSubmit) {
        return
      }
      this.isSubmit = true
      console.log(this.$route.query.distributorId, 'ffffff')
      let { code, data, msg } = await getExchangeCourse({
        openid: this.openid,
        channelId: this.channelId,
        distributorId: this.$route.query.distributorId || '',
        ...this.form
      })
      setTimeout(() => {
        this.isSubmit = false
      }, 1500)
      if (code === ERROR_OK) {
        this.$router.replace({
          name: 'buySuccess',
          query: {
            openid: this.openid,
            distributorId: data.distributorId,
            distributorType: 2,
            channelId: this.channelId
          }
        })
      } else {
        Toast.fail({
          type: "fail",
          message: msg,
          duration: 1000
        })
      }
    },
    async getAppIdInfo () {
      let { code, data } = await getAppId({})
      if (code === ERROR_OK) {
        console.log(data)
        const appId = data.appId
        let timestamp = Math.floor(+new Date() / 1000)
        let nonceStr = timestamp + "1"
        let url = window.location.href.split("#")[0]
        let { code: sdkCode, data: sdkData } = await getSdk({
          timestamp,
          nonceStr,
          url,
          appId
        })
        if (sdkCode === ERROR_OK) {
          const signature = sdkData.signature
          await wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          })
          wx.error(res => {
            console.log(res)
          })
          wx.ready(() => {
            this.updateAppMessageShareData()
            this.updateTimelineShareData()
          })
        }
      }
    },
    updateAppMessageShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      let link = `http://jimuaike.com/wap/#/exchange?openid=${this.openid}&channelId=${this.channelId}`
      wx.updateAppMessageShareData({
        title,
        desc,
        link,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    },
    updateTimelineShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      let link = `http://jimuaike.com/wap/#/exchange?openid=${this.openid}&channelId=${this.channelId}`
      wx.updateTimelineShareData({
        title,
        desc,
        link,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    }
  }
};
</script>
<style lang="less">
.van-cell {
  padding: 10px 6px !important;
}
.van-cell--required::before {
  left: 0px;
}
.van-cell:last-child::after {
  display: block;
}
.van-button--primary {
  padding: 0 0;
  background-color: transparent;
  border: none;
  color: #0293de;
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.login-wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #f4f4f4;
  .content-wrapper {
    flex: 1;
    padding: 30px 30px 0 30px;
    .content {
      padding: 40px 32px;
      background: #fff;
      .content-head {
        display: flex;
        align-items: flex-start;
        border-radius: 16px;
        .label {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 92px;
          height: 34px;
          margin-top: 7px;
          background: linear-gradient(90deg, #fe8124 0%, #ff4c11 100%);
          border-radius: 17px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
        .text {
          margin-left: 12px;
          font-size: 34px;
          text-align: left;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
          line-height: 48px;
        }
      }
      .time {
        margin-top: 40px;
        .time-text {
          display: flex;
          align-content: center;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 45px;
          .label {
            color: #f55029;
          }
        }
        .list {
          margin-top: 16px;
          display: flex;
          align-items: center;
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 175px;
            height: 65px;
            border: 1px solid #f5f5f5;
            background: #f5f5f5;
            border-radius: 8px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            &.active {
              color: #f78019;
              background: #fff2dc;
              border: 1px solid #f78019;
            }
          }
          .item + .item {
            margin-left: 30px;
          }
        }
      }
      .form {
        .form-item {
          margin-top: 60px;
          /deep/ .van-button--primary {
            padding: 0 0;
            background-color: transparent;
            border: none;
            color: #0293de;
            font-size: 16px;
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    height: 120px;
    background: #fff;
    .left {
      display: flex;
      align-items: center;
      .text {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .price {
        display: flex;
        align-items: baseline;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff5330;
        .text {
          font-size: 38px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff5330;
          line-height: 40px;
          text-decoration: line-through;
        }
      }
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 260px;
      height: 90px;
      background: #0293de;
      border-radius: 45px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
